module.exports = __webpack_public_path__ + "img/project_card.ea71a795.png";